import { SizableText, SmartLink, Stack, XStack, YStack, YStackProps, shadowStandard } from '@my/ui'
import { ArticleCategoryTag } from 'app/features/blog/components'
import { SolitoImage } from 'solito/image'

export interface ArticleCardAltProps {
  id: string
  title: string
  shortDescription: string
  featuredImage: {
    url: string
    alt: string
  }
  primaryCategory: {
    name: string
    slug: string
  }
  slug: string
  wrapperStyle?: YStackProps
  imagePriority?: boolean
}

const interactionStyles = {
  hoverStyle: {
    opacity: 0.8,
  },
  pressStyle: {
    opacity: 0.75,
  },
  focusStyle: {
    opacity: 0.7,
  },
}

export const ArticleCardAlt = (props: ArticleCardAltProps) => {
  return (
    <Stack
      className="ArticleCardAlt"
      borderRadius="$3"
      overflow="hidden"
      bc="$white"
      {...shadowStandard}
    >
      <SmartLink
        Component={Stack}
        aria-label="View article"
        tabIndex={-1}
        href={`/life/${props.slug}`}
        btlr="$3"
        btrr="$3"
        overflow="hidden"
        aspectRatio={4 / 3}
        {...interactionStyles}
      >
        <SolitoImage
          src={props.featuredImage.url}
          alt={props.featuredImage.alt || props.title}
          fill
          contentFit="cover"
          sizes="(max-width: 460px) 100vw, (max-width: 768px) 50vw, 300px"
          priority={props.imagePriority}
        />
      </SmartLink>

      {props.primaryCategory?.name && (
        <XStack position="absolute" left="$3.5">
          <ArticleCategoryTag
            name={props.primaryCategory.name}
            href={`/life/categories/${props.primaryCategory.slug}`}
            top="$3.5"
          />
        </XStack>
      )}

      <SmartLink
        Component={YStack}
        href={`/life/${props.slug}`}
        bg="$white"
        p="$4"
        gap="$2"
        $gtSm={{ p: '$6' }}
        hoverStyle={{
          opacity: 0.85,
        }}
        pressStyle={{
          opacity: 0.75,
        }}
        focusStyle={{
          opacity: 0.7,
        }}
      >
        <SizableText numberOfLines={2} color="$overlay12" size="$7" fow="800" textAlign="center">
          {props.title}
        </SizableText>
        {props.shortDescription && (
          <SizableText numberOfLines={2} size="$4" color="$overlay11" fow="400" textAlign="center">
            {props.shortDescription}
          </SizableText>
        )}
      </SmartLink>
    </Stack>
  )
}
